// AI sentinels + the placeholder applied at upload time, all of which mean
// "this document has no resolved category yet". Shared so the dashboard
// modules and the funnel-style FileInput agree on the same set.
const UNRESOLVED_DOCUMENT_CATEGORIES: ReadonlySet<string> = new Set([
  'uncategorized',
  'unknown',
  'multi-document',
  '',
]);

export function isUnresolvedCategory(category: string | undefined | null): boolean {
  return UNRESOLVED_DOCUMENT_CATEGORIES.has(category ?? '');
}

export const hasOtherCategory = (
  categories: ReadonlyArray<{ category: string }> | undefined,
  currentCategory: string | undefined,
): boolean => categories?.some(({ category }) => category !== currentCategory) ?? false;
